export const Features = [
  {
    title: "Engage in Dynamic Gameplay",
    description:
      "Embark on a real-world adventure with Figrun. Navigate maps, locate hidden Figs, and solve puzzles to unlock treasures. Each discovery offers a chance to win valuable Gems, enhancing your gameplay with tangible rewards.",
    name: "Gameplay!",
  },
  {
    title: "we dont do cookie cutter technology",
    description:
      "See Figs come alive in your environment for an immersive experience. Tailor your exploration with filters and preferences to highlight routes and Figs. Built-in features ensure a secure and private adventure every time.",
    name: "cutting edge",
  },
  {
    title: "redefining what instant mean!",
    description:
      "Unlock real money and Gems instantly with each Fig you discover. Our unique real-time reward system ensures that winnings are directly deposited to your account, offering immediate thrilling gaming experience.",
    name: "real time win!",
  },
  {
    title: "Join a Global Community",
    description:
      "Thrive in a Global Community Join an active community where explorers share, compete, and connect. Participate in community challenges, climb leaderboards. engage with users worldwide!",
    name: "community",
  },
  {
    title: "where reality meets adventure right on your phone.",
    description: `1. Download and Dive In: Quick setup with immediate access to your first adventure.
      2.Choose Your Figpass: Start small with Figlet or go big with Figpeak—there's a journey for everyone.
      `,
    name: "quick start guide",
  },
];

export const Steps = [
  {
    step: 1,
    name: 'Download and Dive In',
    description: 'Quick setup with immediate access to your first adventure.',
  },
  {
    step: 2,
    name: 'Choose Your Figpass',
    description: "Start small with Figlet or go big with Figpeak—there's a journey for everyone.",
  },
  {
    step: 3,
    name: 'Hunt for Figs',
    description: "Use the map to find hidden Figs. Solve clues and complete challenges to unlock them.",
  },
  {
    step: 4,
    name: 'Collect and Win',
    description: "Earn Gems for every Fig you find, redeemable for cash or more gameplay opportunities.",
  },
  {
    step: 5,
    name: 'Play with Friends',
    description: "Connect in real-time, see their discoveries, and compete or collaborate.",
  },
  {
    step: 6,
    name: 'Global Leaderboards',
    description: "Climb the ranks by collecting the most Figs and completing challenges quickly.",
  },
]

export const FeatureFigs = {
  minUnlockWorth: 50,
  maxUnlockWorth: 25000,
};